import router from './router'
import store from './store/'  // token  和 权限
import NProgress from 'nprogress' //进度条
import 'nprogress/nprogress.css'//进度条
const title = '后台管理中心';
NProgress.configure({showSpinner: false});
/*在跳转之前执行*/
router.beforeEach((to, from, next) => {
    //权限验证 后期加上
    if (to.meta.title) {
        document.title = to.meta.title + '-' + title
    }
    NProgress.start();
    let token = store.getters.token;
    if (!token &&  to.name != "login" ) {
        next(`/`);
        NProgress.done(store);
    }  else {
        next();
    }

});
/*在跳转之后判断*/
router.afterEach(() => {
    NProgress.done();
});
